module.exports = __webpack_public_path__ + "img/slim_cleanstation27.a9b37af8.jpg";